import { Color } from '../../color.model';

export const pink: Color = {
  light: {
    1: 'hsl(322, 100%, 99.4%)',
    2: 'hsl(323, 100%, 98.4%)',
    3: 'hsl(323, 86.3%, 96.5%)',
    4: 'hsl(323, 78.7%, 94.2%)',
    5: 'hsl(323, 72.2%, 91.1%)',
    6: 'hsl(323, 66.3%, 86.6%)',
    7: 'hsl(323, 62.0%, 80.1%)',
    8: 'hsl(323, 60.3%, 72.4%)',
    9: 'hsl(322, 65.0%, 54.5%)',
    10: 'hsl(322, 63.9%, 50.7%)',
    11: 'hsl(322, 75.0%, 46.0%)',
    12: 'hsl(320, 70.0%, 13.5%)',
  },
  dark: {
    1: 'hsl(318, 25.0%, 9.6%)',
    2: 'hsl(319, 32.2%, 11.6%)',
    3: 'hsl(319, 41.0%, 16.0%)',
    4: 'hsl(320, 45.4%, 18.7%)',
    5: 'hsl(320, 49.0%, 21.1%)',
    6: 'hsl(321, 53.6%, 24.4%)',
    7: 'hsl(321, 61.1%, 29.7%)',
    8: 'hsl(322, 74.9%, 37.5%)',
    9: 'hsl(322, 65.0%, 54.5%)',
    10: 'hsl(323, 72.8%, 59.2%)',
    11: 'hsl(325, 90.0%, 66.4%)',
    12: 'hsl(322, 90.0%, 95.8%)',
  },
};
